<nz-card>
  <button nz-button nzType="primary" class="add-row-button" (click)="addRow()">
    Add New
  </button>

  <nz-table
    #variantTable
    [nzData]="rows"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    nzSize="small"
  >
    <thead>
      <tr>
        <th>{{ 'Quantity' | locale }}</th>
        <th *ngFor="let option of variantOptions">{{ option.Title | locale }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="
          let row of variantTable.data;
          let i = index;
          trackBy: trackByIndex
        "
      >
        <td>
          <nz-input-number
            [(ngModel)]="row.Quantity"
            [nzMin]="1"
            [nzStep]="1"
            [nzPrecision]="0"
            [ngClass]="{ 'invalid-quantity': row.Quantity <= 0 }"
          ></nz-input-number>
        </td>
        <td *ngFor="let option of variantOptions">
          <input nz-input [(ngModel)]="row[option.Name]" />
        </td>
        <td class="actions-cell">
          <button nz-button nzType="link" nzDanger (click)="deleteRow(i)">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div class="submit-row">
    <button nz-button nzType="primary" (click)="onSubmit()" [disabled]="!canSubmit()">
      Submit
    </button>
  </div>
</nz-card>
